import { getConfig } from '@cian/config/browser';
import React from 'react';
import { hydrate } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { ErrorLogComponent } from '@cian/error-log-component';
import { IPopupLinkData } from '../../../shared/types/moderation';
import { CheckAnounceRelevancePopup } from '../../containers/CheckAnounceRelevancePopup';
import { ProlongationPopup } from '../../containers/ProlongationPopup';
import { IUserVerificationSchema } from '../../../shared/repositories/header/entities/user_verification/UserVerificationSchema';
import { IHeaderV1Schema } from '../../../shared/repositories/header/entities/response/HeaderV1Schema';
import { getHttpApi } from '@cian/http-api/browser';
import { getCookie, setCookie } from '../../utils/cookie';
import { fetchCancelUserResponse } from '../../../shared/repositories/moderation-checks-orchestrator/v2/cancel-user-response';

export const initializeCheckAnounceRelevancePopup = () => {
  const popupElement = document.getElementById('anouncements-relevance-popup');
  const config = getConfig();
  const userIsAuthenticated = config.get<boolean>('userIsAuthenticated') as boolean;
  const popupData = config.get<IPopupLinkData>('anouncementLink');
  const logger = getLogger();

  if (userIsAuthenticated) {
    hydrate(
      <ErrorLogComponent logger={logger}>
        <CheckAnounceRelevancePopup popupData={popupData} />
      </ErrorLogComponent>,
      popupElement,
    );
  }
};

export const initializeProlongationPopup = () => {
  const popupElement = document.getElementById('prolongation-popup');
  const config = getConfig();
  const userIsAuthenticated = config.get<boolean>('userIsAuthenticated') as boolean;
  const popupData = config.get<IPopupLinkData>('anouncementLink');
  const logger = getLogger();

  if (userIsAuthenticated) {
    hydrate(
      <ErrorLogComponent logger={logger}>
        <ProlongationPopup popupData={popupData} />
      </ErrorLogComponent>,
      popupElement,
    );
  }
};

const isFailedVerificationWithRetry = (verification: IUserVerificationSchema) => {
  return verification.state === 'failed' && verification.canRetry;
};

export const initializeModerationCheckConstraint = async () => {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();
  const { userVerification, isModerationVerificationEnabled } = config.getStrict<IHeaderV1Schema>('headerData');

  // Проверяем, нужно ли показывать информационный попап о необходимости пройти проверку.
  // Смотрим статус, присланный модерацией
  if (
    !userVerification ||
    !userVerification.id ||
    !userVerification.announcementAddress ||
    !userVerification.offerLink ||
    (userVerification.state !== 'inProgress' && !isFailedVerificationWithRetry(userVerification))
  ) {
    return;
  }

  // Время жизни куки - сутки. Если куки еще совсем нет или она протухла (прошло более суток с момента показа попапа),
  // показываем попап снова
  const userId = window.__header_user_id__ || '';
  const cookieName = 'moderationConstraint' + userId;

  if (getCookie(cookieName)) {
    return;
  }

  const el = document.getElementById('adaptive-header');
  if (!el) {
    return;
  }

  const { renderModerationConstraintPopup } = await import('../../moderation_constraint_popup');
  const verificationUrl = config.getStrict<string>('verification.browserUrl');

  const newEl = document.createElement('div');

  renderModerationConstraintPopup(newEl, {
    address: userVerification.announcementAddress,
    offerLink: userVerification.offerLink,
    isVerificationServiceEnabled: isModerationVerificationEnabled,
    verificationUrl,
    onCancel: () => {
      const parameters = {
        verificationId: userVerification.id as number,
        description: 'Пользователь отказался от проверки',
      };

      // Если не хочет проходить проверку, отправляем в модерацию сигнал об этом
      fetchCancelUserResponse({ httpApi, parameters, config: { requestConfig: { withCredentials: true } } }).catch(
        err => {
          logger.error(err);
        },
      );
    },
    onClose: () => {
      // Откладываем показ еще на сутки
      setCookie(cookieName, '1', 1);
    },
    onAccept: () => {},
  });

  el.appendChild(newEl);
};
